export const MY_PROFILE_NEW = "MY_PROFILE_NEW"
export const MY_PROFILE_NEW_SUCCESS = "MY_PROFILE_NEW_SUCCESS"
export const MY_PROFILE_NEW_ERROR = "MY_PROFILE_NEW_ERROR"
export const MY_PROFILE_NEW_RESET = "MY_PROFILE_NEW_RESET"
